<template>
  <div>
    <b-row>
      <b-col class="col-12 mb-2 mt-4">
        <div class="d-flex align-items-center justify-content-between">
          <h6>ผลการทำข้อสอบ</h6>
          <div class="font-small">
            <a
              :href="`/${company.url}/analytics/exams/member/${memberId}/exam/${examId}/exam-result`"
              target="_blank"
              ><h6>ดูทั้งหมด</h6></a
            >
          </div>
        </div>
      </b-col>
      <b-col class="col-12 mt-1">
        <b-table
          table-class="tbNumber text-left"
          style="overflow-x: auto"
          :items="items"
          :fields="computedFields"
          :tbody-tr-class="rowClass"
          class="text-truncate border"
          small
          sort-icon-left
          responsive="true"
          :busy="isLoading"
          hover
          striped
        >
          <template v-slot:cell(no)="data">
            <span>{{ data.item.no }}</span>
          </template>
          <template v-slot:cell(examDate)="data">
            <span>{{ data.item.createdAt | thaiDateFilterTimestampUTC }}</span>
          </template>
          <template v-slot:cell(totalTimeUsed)="data">
            <span>{{ data.item.totalTimeUsed != null
                ? getTotalTimeUsed(data.item.totalTimeUsed.toFixed(2))
                : getTotalTimeUsed(
                    calculateTimeUsed(data.item.sections).toFixed(2)
                  ) }}</span>
          </template>
          <template v-slot:cell(score)="data">
            <span>{{ data.item.overallResult.score }}</span>
          </template>
          <template v-slot:cell(percent)="data">
            <span>{{ formatNumber((data.item.overallResult.correct * 100) / data.item.overallResult.fullScore ) }} %</span>
          </template>

          <template v-slot:cell(info)="data">
            <div class="text-right">
              <button
                class="btn btn-outline-primary"
                @click="onButtonClick(data.item)"
              >
                ดูข้อมูล
              </button>
            </div>
          </template>
        

          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
        </b-table>
      </b-col>
      <b-col v-if="hasDonutChart" class="col-12 mt-4">
        ผลการทำข้อสอบลำดับที่ {{ activeAnswerSheet }}
      </b-col>
    </b-row>
  </div>
</template>

<script>
import totalTimeUsedMixin from "@/components/pages/analytics/exam/mixins/totalTimeUsed.js";
import dateMixin from "@/components/pages/analytics/shared/mixins/date.js";

export default {
  mixins: [totalTimeUsedMixin, dateMixin],
  props: {
    company: Object,
    examId: String,
    memberId: String,
    totalAnswerSheets: Array,
    hasDonutChart: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fields: [
        { key: "no", label: "ลำดับ" },
        { key: "examDate", label: "วันที่ทำข้อสอบ" },
        { key: "totalTimeUsed", label: "เวลาที่ใช้ทำข้อสอบ" },
        { key: "score", label: "คะแนนที่ได้" },
        { key: "percent", label: "คิดเป็น %" },
      ],
      items: [],
      isLoading: false,
      selectedRowId: null,
      activeAnswerSheet: 1
    };
  },
  watch: {
    async totalAnswerSheets() {
      await this.updateTable();
      if (this.items.length > 0 && this.hasDonutChart) {
        this.selectedRowId = this.items[0].id;
      }
    },
  },
  computed: {
    computedFields() {
      const baseFields = [...this.fields];
      if (this.hasDonutChart) {
        baseFields.push({ key: 'info', label: '', thStyle: { width: "5%" },});
      }
      return baseFields;
    },
  },
  methods: {
    formatNumber(num) {
      return parseFloat(num).toFixed(2);
    },
    async updateTable() {
      this.isLoading = true;
      this.items = this.totalAnswerSheets.slice(0, 10);
      for (let i = 0; i < this.items.length; i++) {
        this.items[i].no = i + 1;
      }
      this.isLoading = false;
    },
    calculateTimeUsed(sections) {
      var time = 0;
      sections.forEach((i) => {
        i.answers.forEach((j) => {
          if (j.timeUsed != null) {
            time = time + j.timeUsed;
          }
        });
      });
      return time;
    },
    onButtonClick(item) {
      this.selectedRowId = item.id;
      this.activeAnswerSheet = item.no
      this.$emit('selectedAnswerSheet', item);
    },
    rowClass(item) {
      return item.id === this.selectedRowId ? 'exam-table-highlight-row' : '';
    },
  },
};
</script>

<style scoped>
.font-small {
  font-size: 0.8rem;
}
</style>

<style>
.exam-table-highlight-row {
  background-color: #BADBFF !important; /* Light blue background */
}
</style>
